import isHotKey from 'is-hotkey';
import { DATABASE_ADD_ROW } from '../../../../../types/AnalyticsTypes'; // We can't direclty use mod for testing purpose

function isHotKeyWithMod(key, event) {
  return isHotKey("ctrl+".concat(key), event) || isHotKey("cmd+".concat(key), event);
}

export default function onKeyDown(event, database) {
  var _database$getSelectio = database.getSelection(),
      activeKey = _database$getSelectio.activeKey;

  if (!activeKey || event.defaultPrevented) {
    return;
  }

  var isFocused = database.isFocused(activeKey);
  var isMetaKey = event.altKey || event.metaKey || event.ctrlKey;

  if (!isFocused && isHotKeyWithMod('z', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.undo();
  }

  if (!isFocused && isHotKeyWithMod('shift+z', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.redo();
  }

  if (isHotKey('esc', event)) {
    event.preventDefault();
    event.stopPropagation();
    return isFocused ? database.activate() : database.blur();
  } // On delete key, remove content if not focused


  if (!isFocused && (isHotKey('delete', event) || isHotKey('backspace', event))) {
    event.preventDefault();
    event.stopPropagation();
    return database.deleteSelectedFields();
  } // Focus record after


  if (!isFocused && isHotKey('shift+enter', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.activateRecordAfter().focus();
  } // Activate on cmd+enter when focused


  if (isFocused && isHotKeyWithMod('enter', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.activate();
  } // Insert below on cmd+enter


  if (!isFocused && isHotKeyWithMod('enter', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.insertRecordAfter().activateRecordAfter().command('track', DATABASE_ADD_ROW, {
      source: 'Pressed mod+enter'
    });
  } // Focus record after


  if (!isFocused && isHotKey('alt+enter', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.insertRecord().activateLastRecord().command('track', DATABASE_ADD_ROW, {
      source: 'Pressed alt+enter'
    });
  } // On shift+tab, go to previous cell


  if (isHotKey('shift+tab', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.activateColumnBefore().focus();
  } // On tab, go to next cell


  if (isHotKey('tab', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.activateColumnAfter().focus();
  } // On enter key, activate next record


  if (isHotKey('enter', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.run('onEnter', event);
  } // On left key, activate previous field


  if (isHotKey('shift?+left', event) && !isFocused) {
    event.preventDefault();
    event.stopPropagation();
    return database.activateColumnBefore();
  } // On right key, activate previous field


  if (isHotKey('shift?+right', event) && !isFocused) {
    event.preventDefault();
    event.stopPropagation();
    return database.activateColumnAfter();
  } // On up key, activate previous record


  if (isHotKey('shift?+up', event) && !isFocused) {
    event.preventDefault();
    event.stopPropagation();
    return database.activateRecordBefore();
  } // On down key, activate next field


  if (isHotKey('shift?+down', event) && !isFocused) {
    event.preventDefault();
    event.stopPropagation();
    return database.activateRecordAfter();
  } // On ctrl+a, select all the cells


  if (!isFocused && isHotKeyWithMod('a', event)) {
    event.preventDefault();
    event.stopPropagation();
    return database.activate().selectAll();
  } // By default, focus the active cell if not


  if (!isFocused && !isMetaKey && event.key !== 'Shift') {
    event.preventDefault();
    event.stopPropagation();
    database.run('onStartTyping', event);
    return database;
  } //Hotkeys reserved for app


  if (isHotKeyWithMod('k', event)) {
    //Quick-switch / Search
    return database.blur();
  }
}